
class ThumbnailFarm {
  static to(type, url) {
    return `${appInfo.thumbnailBaseUrl}/${type}/?scode=mtistory2&fname=${encodeURIComponent(url)}`;
  }

  static from(url) {
    try {
      const obj = new URL(url);
      const orgUrl = obj.searchParams.get('fname');
      return orgUrl ? orgUrl : url;
    } catch (e) {
      // ignore
      return url
    }
  }
}

export default  ThumbnailFarm;
